import type { Training } from "../../../../api/training/Training.typed";
import type { Module, Criteria } from "../../../../api/followup/Followup.typed";
import type { Comment } from "../../../../api/zekay/comments";
import { colorTokens } from "../../../../styles/globalStyles";

export type CriteriaSummary = {
  description: string;
  status: string;
  comments: Comment[];
  isComplete: boolean;
};

export async function generateModuleSummary(
  training: Training,
): Promise<Record<string, CriteriaSummary[]>> {
  const moduleSummaries: Record<string, CriteriaSummary[]> = {};

  if (!training.FollowUpSheet?.Form || !training.FollowUpSheet.Form.modules) {
    return moduleSummaries;
  }

  const form = training.FollowUpSheet.Form;
  form.modules.forEach((module: Module) => {
    if (!moduleSummaries[module.name]) {
      moduleSummaries[module.name] = [];
    }

    module.criteria.forEach((criterion: Criteria) => {
      const options = criterion.options || [];
      const responses = criterion.status || [];
      const missingOptions = options.filter((opt: string) => !responses.includes(opt));

      let status = "";

      if (options.includes("OK") && options.includes("A retravailler")) {
        status = `${responses.join(", ") || "Non rempli"}`;
      } else {
        const given = responses.length ? `Validé : ${responses.join(", ")}\n` : "";
        const missing = missingOptions.length ? `Manquant : ${missingOptions.join(", ")}` : "";
        status = `${given}${missing}`;
      }

      let isComplete = false;
      if (options.includes("OK") && options.includes("A retravailler")) {
        isComplete = responses.includes("OK");
      } else {
        isComplete = missingOptions.length === 0;
      }

      const commentsArray = criterion.comments_array || [];

      moduleSummaries[module.name].push({
        description: criterion.description,
        status,
        comments: commentsArray,
        isComplete,
      });
    });
  });

  return moduleSummaries;
}

export function getColorForCriterion(criterion: CriteriaSummary): string {
  if (criterion.status.includes("OK")) {
    criterion.isComplete = true;
  }
  if (criterion.isComplete) {
    return colorTokens.status.success;
  }
  if (criterion.status.includes("Manquant") && criterion.status.includes("Validé")) {
    return colorTokens.status.warning;
  }
  if (criterion.status.includes("A retravailler")) {
    return colorTokens.status.warning;
  }
  return colorTokens.text.primary;
}
